<div class="message">
    If your AWB arrived before {{ arrivedDay }}, please
    <a id="redirect-link" class="modal-link" [href]="redirectionUrl | sanitize: 'url'" target="_NEW">click here</a>
    to complete your payment.
</div>
